import React from 'react'
import { useTranslation } from 'react-i18next'
import useCountdown from '@/util/hook/useCountdown.ts'
import { formatRemaining } from '@/util/testSession.ts'

interface IProps {
    name: string
    serial: string
    meta: string
    endsAt: string
    canEnd: boolean
    isBusy?: boolean
    emphasizeRemaining?: boolean
    onEnd?: () => void
}

const TestSessionRow: React.FC<IProps> = ({
    name,
    serial,
    meta,
    endsAt,
    canEnd,
    isBusy,
    emphasizeRemaining,
    onEnd
}) => {
    const { t } = useTranslation()
    const remaining = useCountdown(endsAt)

    return (
        <li className={'test-session-row'}>
            <div className={'test-session-row__who'}>
                <strong>{name}</strong>
                <span className={'test-session-row__meta'}>
                    <span className={'test-session-row__serial'}>{serial}</span>
                    <span aria-hidden>·</span>
                    <span className={'test-session-row__when'}>{meta}</span>
                </span>
            </div>
            <span className={`test-session-row__remaining ${emphasizeRemaining ? 'is-soon' : ''}`}>
                {t('testMode.remaining', { time: formatRemaining(remaining) })}
            </span>
            {canEnd && (
                <button
                    type={'button'}
                    className={'test-mode-button'}
                    disabled={isBusy}
                    aria-label={t('testMode.action.endFor', { name })}
                    onClick={onEnd}>
                    {t('testMode.action.end')}
                </button>
            )}
        </li>
    )
}

export default TestSessionRow
